var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isNoData)?_c('div',{staticClass:"unicom-blank-page"},[_c('van-empty',{staticClass:"custom-image",attrs:{"image":_vm.imgUrl ? _vm.imgUrl : '/pub/online/20240318/111f3001f4b2d44a.png',"description":_vm.text}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }